import { Action } from '@ngrx/store';
import { TFactoryConfigActionType } from './factory-config.models';
import {
  TRESPONSE_EFFICIENCY_CONFIG,
  TREQUEST_UPDATE_EFFICIENCY_CONFIG,
  TREQUEST_UPDATE_BENCHMARKING_CONFIG,
  TRESPONSE_BENCHMARKING_CONFIG,
  TRESPONSE_OTL_OPL_CONFIG,
  TREQUEST_UPDATE_OTL_OPL_CONFIG,
  TRESPONSE_SED_CONFIG,
  TREQUEST_UPDATE_SED_CONFIG,
  TREQUEST_UPDATE_EXPECTED_DATE_CONFIG,
  TRESPONSE_EXPECTED_DATE_CONFIG,
  TRESPONSE_TNA_TARGET_UPDATES_CONFIG,
  TREQUEST_TNA_TARGET_UPDATES_CONFIG_UPDATE,
  TRESPONSE_AUTO_PLAN_CONFIG,
  TREQUEST_UPDATE_AUTO_PLAN_CONFIG,
} from '@monorepo/types';

export class GetFactoryEfficiencyConfig implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryEfficiencyConfig;
}

export class GetFactoryEfficiencyConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryEfficiencyConfigSuccess;
  constructor(public res: TRESPONSE_EFFICIENCY_CONFIG) {}
}

export class GetFactoryEfficiencyConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryEfficiencyConfigFailure;
}

export class SetEfficiencyLoader implements Action {
  readonly type = TFactoryConfigActionType.SetEfficiencyLoader;
  constructor(public showLoader: boolean) {}
}

export class UpdateFactoryEfficiencyConfig implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryEfficiencyConfig;
  constructor(public payload: TREQUEST_UPDATE_EFFICIENCY_CONFIG) {}
}

export class UpdateFactoryEfficiencyConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryEfficiencyConfigSuccess;
}

export class UpdateFactoryEfficiencyConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryEfficiencyConfigFailure;
}

export class GetFactoryBenchmarkingConfig implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryBenchmarkingConfig;
}

export class GetFactoryBenchmarkingConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryBenchmarkingConfigSuccess;
  constructor(public res: TRESPONSE_BENCHMARKING_CONFIG) {}
}

export class GetFactoryBenchmarkingConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryBenchmarkingConfigFailure;
}

export class SetBenchmarkingLoader implements Action {
  readonly type = TFactoryConfigActionType.SetBenchmarkingLoader;
  constructor(public showLoader: boolean) {}
}

export class UpdateFactoryBenchmarkingConfig implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryBenchmarkingConfig;
  constructor(public payload: TREQUEST_UPDATE_BENCHMARKING_CONFIG) {}
}

export class UpdateFactoryBenchmarkingConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryBenchmarkingConfigSuccess;
}

export class UpdateFactoryBenchmarkingConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryBenchmarkingConfigFailure;
}

export class GetFactoryOtlOplConfig implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryOtlOplConfig;
}

export class GetFactoryOtlOplConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryOtlOplConfigSuccess;
  constructor(public res: TRESPONSE_OTL_OPL_CONFIG) {}
}

export class GetFactoryOtlOplConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryOtlOplConfigFailure;
}
export class SetOtlOplLoader implements Action {
  readonly type = TFactoryConfigActionType.SetOtlOplLoader;
  constructor(public showLoader: boolean) {}
}

export class UpdateFactoryOtlOplConfig implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryOtlOplConfig;
  constructor(public payload: TREQUEST_UPDATE_OTL_OPL_CONFIG) {}
}

export class UpdateFactoryOtlOplConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryOtlOplConfigSuccess;
}

export class UpdateFactoryOtlOplConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryOtlOplConfigFailure;
}

export class GetFactorySedConfig implements Action {
  readonly type = TFactoryConfigActionType.GetFactorySedConfig;
}

export class GetFactorySedConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.GetFactorySedConfigSuccess;
  constructor(public res: TRESPONSE_SED_CONFIG) {}
}

export class GetFactorySedConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.GetFactorySedConfigFailure;
}
export class SetSedLoader implements Action {
  readonly type = TFactoryConfigActionType.SetSedLoader;
  constructor(public showLoader: boolean) {}
}

export class UpdateFactorySedConfig implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactorySedConfig;
  constructor(public payload: TREQUEST_UPDATE_SED_CONFIG) {}
}

export class UpdateFactorySedConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactorySedConfigSuccess;
}

export class UpdateFactorySedConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactorySedConfigFailure;
}

export class GetFactoryExpectedDateConfig implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryExpectedDateConfig;
}

export class GetFactoryExpectedDateConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryExpectedDateConfigSuccess;
  constructor(public res: TRESPONSE_EXPECTED_DATE_CONFIG) {}
}

export class GetFactoryExpectedDateConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.GetFactoryExpectedDateConfigFailure;
}
export class SetExpectedDateLoader implements Action {
  readonly type = TFactoryConfigActionType.SetExpectedDateLoader;
  constructor(public showLoader: boolean) {}
}

export class UpdateFactoryExpectedDateConfig implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryExpectedDateConfig;
  constructor(public payload: TREQUEST_UPDATE_EXPECTED_DATE_CONFIG) {}
}

export class UpdateFactoryExpectedDateConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryExpectedDateConfigSuccess;
}

export class UpdateFactoryExpectedDateConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.UpdateFactoryExpectedDateConfigFailure;
}

export class UpdateTnaTargetUpdatesConfig implements Action {
  readonly type = TFactoryConfigActionType.UpdateTnaTargetUpdatesConfig;
  constructor(public payload: TREQUEST_TNA_TARGET_UPDATES_CONFIG_UPDATE) {}
}

export class UpdateTnaTargetUpdatesConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.UpdateTnaTargetUpdatesConfigSuccess;
}

export class UpdateTnaTargetUpdatesConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.UpdateTnaTargetUpdatesConfigFailure;
}

export class GetAllFactoryConfigs implements Action {
  readonly type = TFactoryConfigActionType.GetAllFactoryConfigs;
}

export class GetAllFactoryConfigsSuccess implements Action {
  readonly type = TFactoryConfigActionType.GetAllFactoryConfigsSucccess;
  constructor(
    public efficiencyRes: TRESPONSE_EFFICIENCY_CONFIG | null,
    public benchmarkingRes: TRESPONSE_BENCHMARKING_CONFIG | null,
    public otlOplRes: TRESPONSE_OTL_OPL_CONFIG | null,
    public sedRes: TRESPONSE_SED_CONFIG | null,
    public expectedDateRes: TRESPONSE_EXPECTED_DATE_CONFIG | null,
    public tnaTargetUpdatesRes: TRESPONSE_TNA_TARGET_UPDATES_CONFIG | null,
    public autoPlanRes: TRESPONSE_AUTO_PLAN_CONFIG | null,
  ) {}
}

export class GetAllFactoryConfigsFailure implements Action {
  readonly type = TFactoryConfigActionType.GetAllFactoryConfigsFailure;
}

export class GetTnaTargetUpdatesConfig implements Action {
  readonly type = TFactoryConfigActionType.GetTnaTargetUpdatesConfig;
}

export class GetTnaTargetUpdatesConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.GetTnaTargetUpdatesConfigSuccess;
  constructor(public res: TRESPONSE_TNA_TARGET_UPDATES_CONFIG) {}
}

export class GetTnaTargetUpdatesConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.GetTnaTargetUpdatesConfigFailure;
}

export class SetTnaTargetUpdatesConfigLoader implements Action {
  readonly type = TFactoryConfigActionType.SetTnaTargetUpdatesConfigLoader;
  constructor(public showLoader: boolean) {}
}

export class GetAutoPlanConfig implements Action {
  readonly type = TFactoryConfigActionType.GetAutoPlanConfig;
}

export class GetAutoPlanConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.GetAutoPlanConfigSuccess;
  constructor(public res: TRESPONSE_AUTO_PLAN_CONFIG) {}
}

export class GetAutoPlanConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.GetAutoPlanConfigFailure;
}

export class SetAutoPlanConfigLoader implements Action {
  readonly type = TFactoryConfigActionType.SetAutoPlanConfigLoader;
  constructor(public showLoader: boolean) {}
}

export class UpdateAutoPlanConfig implements Action {
  readonly type = TFactoryConfigActionType.UpdateAutoPlanConfig;
  constructor(public payload: TREQUEST_UPDATE_AUTO_PLAN_CONFIG) {}
}

export class UpdateAutoPlanConfigSuccess implements Action {
  readonly type = TFactoryConfigActionType.UpdateAutoPlanConfigSuccess;
}

export class UpdateAutoPlanConfigFailure implements Action {
  readonly type = TFactoryConfigActionType.UpdateAutoPlanConfigFailure;
}
export type TFactoryConfigActions =
  | GetFactoryEfficiencyConfig
  | GetFactoryEfficiencyConfigSuccess
  | GetFactoryEfficiencyConfigFailure
  | SetEfficiencyLoader
  | UpdateFactoryEfficiencyConfig
  | UpdateFactoryEfficiencyConfigSuccess
  | UpdateFactoryEfficiencyConfigFailure
  | UpdateFactoryBenchmarkingConfig
  | UpdateFactoryBenchmarkingConfigSuccess
  | UpdateFactoryBenchmarkingConfigFailure
  | GetFactoryBenchmarkingConfig
  | GetFactoryBenchmarkingConfigSuccess
  | GetFactoryBenchmarkingConfigFailure
  | SetBenchmarkingLoader
  | GetFactoryOtlOplConfig
  | GetFactoryOtlOplConfigSuccess
  | GetFactoryOtlOplConfigFailure
  | UpdateFactoryOtlOplConfig
  | UpdateFactoryOtlOplConfigSuccess
  | UpdateFactoryOtlOplConfigFailure
  | SetOtlOplLoader
  | GetFactorySedConfig
  | GetFactorySedConfigSuccess
  | GetFactorySedConfigFailure
  | UpdateFactorySedConfig
  | UpdateFactorySedConfigSuccess
  | UpdateFactorySedConfigFailure
  | SetSedLoader
  | GetFactoryExpectedDateConfig
  | GetFactoryExpectedDateConfigSuccess
  | GetFactoryExpectedDateConfigFailure
  | SetExpectedDateLoader
  | UpdateFactoryExpectedDateConfig
  | UpdateFactoryExpectedDateConfigFailure
  | GetAllFactoryConfigs
  | GetAllFactoryConfigsSuccess
  | GetAllFactoryConfigsFailure
  | GetTnaTargetUpdatesConfig
  | GetTnaTargetUpdatesConfigSuccess
  | GetTnaTargetUpdatesConfigFailure
  | SetTnaTargetUpdatesConfigLoader
  | UpdateTnaTargetUpdatesConfig
  | UpdateTnaTargetUpdatesConfigSuccess
  | UpdateTnaTargetUpdatesConfigFailure
  | GetAutoPlanConfig
  | GetAutoPlanConfigSuccess
  | GetAutoPlanConfigFailure
  | SetAutoPlanConfigLoader
  | UpdateAutoPlanConfig
  | UpdateAutoPlanConfigSuccess
  | UpdateAutoPlanConfigFailure;
